import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { SystezaLogo } from '../ui'

const NAV_LINKS = [
  { label: 'Pricing',   to: '/pricing' },
  { label: 'Blog',      to: '/blog' },
  { label: 'About',     to: '/about' },
  { label: 'Contact',   to: '/contact' },
]

export default function PublicLayout() {
  const navigate = useNavigate()

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-base)' }}>
      {/* Navbar */}
      <nav className="border-b" style={{ background: 'rgba(4,14,42,0.95)', backdropFilter: 'blur(20px)', borderColor: 'var(--border-subtle)' }}>
        <div className="max-w-6xl mx-auto px-6 flex items-center justify-between h-16">
          {/* Logo */}
          <NavLink to="/" className="flex items-center gap-2.5 group">
            <SystezaLogo size={30} />
            <span className="text-lg font-display font-black text-white tracking-tight">Systeza</span>
          </NavLink>

          {/* Nav links */}
          <div className="hidden md:flex items-center gap-1">
            {NAV_LINKS.map(link => (
              <NavLink key={link.to} to={link.to}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-lg text-sm font-medium transition-colors ${isActive ? 'text-white bg-white/8' : 'text-[var(--text-muted)] hover:text-white hover:bg-white/4'}`
                }>
                {link.label}
              </NavLink>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex items-center gap-3">
            <button onClick={() => navigate('/login')}
              className="text-sm font-semibold text-[var(--text-muted)] hover:text-white transition-colors">
              Log in
            </button>
            <button onClick={() => navigate('/register')}
              className="btn-primary text-xs py-2 px-5">
              Get Started
            </button>
          </div>
        </div>
      </nav>

      {/* Page content */}
      <main>
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="border-t mt-20" style={{ borderColor: 'var(--border-subtle)' }}>
        <div className="max-w-6xl mx-auto px-6 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Brand */}
            <div>
              <div className="flex items-center gap-2 mb-3">
                <SystezaLogo size={24} />
                <span className="text-sm font-display font-bold text-white">Systeza</span>
              </div>
              <p className="text-xs text-[var(--text-dim)] leading-relaxed">
                Infrastructure management, marketing automation, AI documentation, and integrations — all in one platform.
              </p>
            </div>

            {/* Product */}
            <div>
              <p className="text-[10px] font-bold uppercase tracking-widest text-[var(--text-dim)] mb-3">Product</p>
              <div className="space-y-2">
                {['Infra', 'Engage', 'Automations', 'Hub'].map(m => (
                  <p key={m} className="text-sm text-[var(--text-muted)] hover:text-white cursor-pointer transition-colors">{m}</p>
                ))}
              </div>
            </div>

            {/* Company */}
            <div>
              <p className="text-[10px] font-bold uppercase tracking-widest text-[var(--text-dim)] mb-3">Company</p>
              <div className="space-y-2">
                {NAV_LINKS.map(link => (
                  <NavLink key={link.to} to={link.to}
                    className="block text-sm text-[var(--text-muted)] hover:text-white transition-colors">
                    {link.label}
                  </NavLink>
                ))}
              </div>
            </div>

            {/* Legal */}
            <div>
              <p className="text-[10px] font-bold uppercase tracking-widest text-[var(--text-dim)] mb-3">Legal</p>
              <div className="space-y-2">
                {['Privacy Policy', 'Terms of Service', 'Security'].map(item => (
                  <p key={item} className="text-sm text-[var(--text-muted)] hover:text-white cursor-pointer transition-colors">{item}</p>
                ))}
              </div>
            </div>
          </div>

          <div className="border-t mt-8 pt-6 flex items-center justify-between" style={{ borderColor: 'var(--border-subtle)' }}>
            <p className="text-xs text-[var(--text-dim)]">&copy; {new Date().getFullYear()} Systeza. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}
